import VueRouter, { RouteConfig } from 'vue-router'
import { AddressType } from 'kuaidong-model'

const DeliveryAddressEdit = () => import('../views/DeliveryAddressEdit.vue')

export const addressRoute: RouteConfig = {
  path: '/delivery-address-edit',
  name: 'delivery_address_edit',
  component: DeliveryAddressEdit,
  props: (route) => ({ ...route.query, ...route.params, addressType: Number(route.query.addressType) }),
  meta: {
    title: '收货地址',
  },
}

const RAddress: RouteConfig[] = [addressRoute]

export default RAddress

export function navigateToDeliveryAddress(router: VueRouter, addressType: AddressType) {
  router.push({ name: addressRoute.name, query: { addressType: `${addressType}` } })
}
